<template>
  <div class="login">
    <div class="container">
      <v-snackbar v-model="loginSuccess" color="success" top>
        <span>
          Autenticidade verificada. Sua nota será baixada em seguida para
          visualização.
        </span>
        <v-btn color="info" @click="loginSuccess = false">Ok</v-btn>
      </v-snackbar>

      <v-snackbar color="error" v-model="loginFail" top>
        <span>
          Falha na autenticação! Favor verificar os dados informados ou entre
          em contato com a Prefeitura.
        </span>
        <v-btn color="info" @click="loginFail = false">Fechar</v-btn>
      </v-snackbar>

      <h1 class="display-1 my-3">Empresas autorizadas para emissão</h1>
      <v-divider></v-divider>
      <v-row wrap justify="center">
        <v-flex xs12 sm6 xl4>
          <v-card hover class="ma-4">
            <v-card-title>Dados da empresa</v-card-title>
            <v-card-text>
              <v-form ref="form" class="my-3">
                <v-text-field
                  v-mask="['###.###.###-##', '##.###.###/####-##']"
                  clearable
                  v-model="cpfCnpj"
                  :rules="regrasObrigacao"
                  label="CNPJ do Prestador de Serviços"
                  required
                  prepend-icon="account_circle"
                ></v-text-field>

                <v-text-field
                  clearable
                  v-model="nomeRazaoSocial"
                  :rules="regrasObrigacao"
                  label="Razão Social"
                  required
                  prepend-icon="description"
                ></v-text-field>

                <v-text-field
                  clearable
                  v-model="endereco"
                  :rules="regrasObrigacao"
                  label="Endereço"
                  required
                  prepend-icon="location_on"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="teal lighten-1" dark type="submit" @click="pesquisaEmpresas">
                <v-icon small left>check_circle</v-icon>
                <span>Verificar</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mask } from "vue-the-mask";
import Swal from "sweet-alert";

export default {
  directives: { mask },
  data() {
    return {
      cpfCnpj: null,
      nomeRazaoSocial: null,
      endereco: null,
      regrasObrigacao: [v => !!v || "Campo obrigatório!"],
      loginSuccess: false,
      loginFail: false,
      listaEmpresas: null
    };
  },
  methods: {
    pesquisaEmpresas() {
      const protocol = window.location.protocol;
      const hostname = window.location.hostname;
      const port = window.location.port == "8081" ? "8080" : window.location.port;

      axios.defaults.baseURL = `${protocol}//${hostname}:${port}/notafiscal-ws/servico/`;

      // console.log(axios.defaults.baseURL);

      if (this.cpfCnpj) {
        this.cpfCnpj = this.removeMask(this.cpfCnpj);
      }

      if (this.$refs.form.validate()) {
        axios("empresa", {
          method: "GET",
          responseType: "json",
          headers: {
            multiTenantId: 8,
            cpfCnpj: this.cpfCnpj,
            nomeRazaoSocial: this.nomeRazaoSocial,
            endereco: this.endereco
          }
        }).then(res => {
          this.listaEmpresas = res.data;

          if (this.listaEmpresas.length) {
            // Swal.fire({
            //     title: 'Resultado pesquisa',
            //     text: "Consulta de empresa(s) efetuado com sucesso.",
            //     type: 'success',
            //     showCancelButton: false,
            //     confirmButtonText: 'OK'
            // })
          } else {
            Swal.fire({
              title: "Resultado pesquisa",
              text:
                "Consulta de empresa(s) não retornou dados com esse(s) filtro(s).",
              type: "error",
              confirmButtonText: "OK"
            });
          }
        });
      }
    },
    removeMask(mask) {
      return mask.replace(/\D/g, "");
    }
  }
};
</script>
